import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1E3A5F] text-white pt-16 pb-8" data-id="element-56">
      <div className="container mx-auto px-4 md:px-6" data-id="element-57">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-58">
          {/* Brand Column */}
          <div className="space-y-4" data-id="element-59">
            <div data-id="element-60">
              <h3 className="text-xl font-bold leading-none" data-id="element-61">LUCKY DUCK</h3>
              <p className="text-xs text-gray-300 tracking-wider" data-id="element-62">
                BATHROOM COMPANY
              </p>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed" data-id="element-63">
              Lucky ducks like you deserve the best! We provide quality
              craftsmanship, honest pricing, and stress-free bathroom remodeling
              for Northern Indiana.
            </p>
            <div className="flex gap-4" data-id="element-64">
              <a href="https://www.facebook.com/luckyduckbath" target="_blank" rel="noopener noreferrer" className="h-10 w-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#8BA888] transition-colors" aria-label="Visit our Facebook page" data-id="element-65">
                <Facebook className="h-5 w-5" data-id="element-66" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-67">
            <h4 className="text-lg font-semibold mb-6 text-white" data-id="element-68">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-69">
              <li data-id="element-70">
                <Link to="/" className="text-gray-300 hover:text-white transition-colors" data-id="element-71">
                  Home
                </Link>
              </li>
              <li data-id="element-72">
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors" data-id="element-73">
                  About Us
                </Link>
              </li>
              <li data-id="element-74">
                <Link to="/faq" className="text-gray-300 hover:text-white transition-colors" data-id="element-75">
                  FAQ
                </Link>
              </li>
              <li data-id="element-76">
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors" data-id="element-77">
                  Contact
                </Link>
              </li>
              <li data-id="element-78">
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors" data-id="element-79">
                  Request Consultation
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-80">
            <h4 className="text-lg font-semibold mb-6 text-white" data-id="element-81">
              Our Services
            </h4>
            <ul className="space-y-3" data-id="element-82">
              <li data-id="element-83">
                <Link to="/services/full-bathroom-remodeling" className="text-gray-300 hover:text-white transition-colors" data-id="element-84">
                  Full Bathroom Remodeling
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/services/tub-to-shower-conversion" className="text-gray-300 hover:text-white transition-colors" data-id="element-86">
                  Tub-to-Shower Conversions
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/services/custom-tile-work" className="text-gray-300 hover:text-white transition-colors" data-id="element-88">
                  Custom Tile Work
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/services/vanity-installation" className="text-gray-300 hover:text-white transition-colors" data-id="element-90">
                  Vanity Installation
                </Link>
              </li>
              <li data-id="element-91">
                <Link to="/services/accessibility-upgrades" className="text-gray-300 hover:text-white transition-colors" data-id="element-92">
                  Accessibility Upgrades
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="/services/flooring-and-lighting" className="text-gray-300 hover:text-white transition-colors" data-id="element-94">
                  Flooring & Lighting
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-95">
            <h4 className="text-lg font-semibold mb-6 text-[#8BA888]" data-id="element-96">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-97">
              <li className="flex items-start gap-3" data-id="element-98">
                <MapPin className="h-5 w-5 text-[#8BA888] shrink-0 mt-0.5" data-id="element-99" />
                <span className="text-gray-300" data-id="element-100">
                  Serving Northern Indiana
                  <br data-id="element-101" />
                  and surrounding areas
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-102">
                <Phone className="h-5 w-5 text-[#8BA888] shrink-0" data-id="element-103" />
                <a href="tel:5749141522" className="text-gray-300 hover:text-white transition-colors" data-id="element-104">
                  (574) 914-1522
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-105">
                <Mail className="h-5 w-5 text-[#8BA888] shrink-0" data-id="element-106" />
                <a href="mailto:info@luckyduckbath.com" className="text-gray-300 hover:text-white transition-colors" data-id="element-107">
                  info@luckyduckbath.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-sm text-gray-400" data-id="element-108">
          <p data-id="element-109">
            &copy; {new Date().getFullYear()} Lucky Duck Bathroom Company. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}